import { addDoc, collection } from "@firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const CreateAttendanceController = async (e, uid) => {
  try {
    const AttendanceCollection = collection(db, "Attendance");

    const data = HelperForMetaData({
      ...e,
      uid: uid,
    });
    await addDoc(AttendanceCollection, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default CreateAttendanceController;
